import { PropsWithChildren, useRef } from "react";
import { twMerge } from "tailwind-merge";

import { Avatar } from "~/common/components";
import { OrganizationTeamMemberWithProvider, Styled } from "~/common/utils";

interface IntroductionCheckinProviderMessageProps
  extends PropsWithChildren, Styled {
  greeting: string;
  checkinTeamMember: OrganizationTeamMemberWithProvider;
}

export const IntroductionCheckinProviderMessage = ({
  children,
  greeting,
  checkinTeamMember,
  className,
}: IntroductionCheckinProviderMessageProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div
      className={twMerge(
        "relative flex h-full w-full flex-col items-center sm:w-3/5 md:text-base xl:w-3/4",
        className,
      )}
      ref={containerRef}
    >
      <div className="absolute flex max-h-full w-full flex-col gap-4 overflow-y-auto rounded-2xl bg-slate-50 p-4 text-gray-70">
        {children}

        <div className="flex items-center justify-between">
          <p>
            {greeting} <br />
            <strong className="text-base font-semibold">
              {checkinTeamMember.team_member.signature_name}
            </strong>
          </p>
          <Avatar
            src={checkinTeamMember.team_member.profile_picture_path}
            alt="ProfilePicture"
            className="w-1/4"
          />
        </div>
      </div>
    </div>
  );
};
